import categories from "../components/data/categorydata";
import categoriesGermany from "../components/data/categorydatagermany";
import categoriesAsiacell from "../components/data/categorydataAsiacell";

export default{
    SUBDOMAINS: [
        { name: "iq", operator: "ZAIN_IRAQ"},
        { name: "de", operator: "NTH_GERMANY"},
        { name:"demo", operator: "DEMO"},
        { name: "asiacell", operator: "ASIACELL_IRAQ"},
        { name:"127",operator:'DEMO'},
        { name:"dz", operator:"ZAIN_IRAQ"},
        { name:"france", operator:"NTH_FRANCE"},
        { name:"ro", operator:"ROMANIA"},
        { name: "ae", operator: "ZAIN_IRAQ"},
        { name: "pol", operator: "POLAND"},
        { name: "zkw", operator: "ZAIN_KUWAIT"},
        { name:"wellbeprime", operator: "DEMO"},
        { name:"lk", operator: "SIRLANKA"},
        { name:"bn", operator: "BANGLADESH"},
        {name:"ch",operator:"NTH_GERMANY"},
        {name:"aidemo",operator:"DEMO"},
        {name:"alg",operator:"OOREDOO_ALGERIA"}
    ],
    Operators: {
        // zain and kortek
        ZAIN_IRAQ:{
            COUNTRY:'iq',
            CATEGORIES: categories,
            DEFAULT_LANG: { CODE: "en" },
            AVAILABLE_LANGUAGES: [
                { CODE: "ar" },
                { CODE: "en" },
            ]
        },
        ETISALAT_UAE:{
            COUNTRY:'ae',
            CATEGORIES: categories,
            DEFAULT_LANG: { CODE: "en" },
            AVAILABLE_LANGUAGES: [
                { CODE: "ar" },
                { CODE: "en" },
            ]

        },
         // zain kuwait 
         ZAIN_KUWAIT:{
            COUNTRY:'kw',
            CATEGORIES: categories,
            DEFAULT_LANG: { CODE: "en" },
            AVAILABLE_LANGUAGES: [
                { CODE: "ar" },
                { CODE: "en" },
            ]
        },
        // denmark
        NTH_GERMANY:{
            COUNTRY:'de',
            CATEGORIES: categoriesGermany,
            DEFAULT_LANG: { CODE: "de"  },
            AVAILABLE_LANGUAGES: [
                { CODE: "de" },
            ]
        },
        DEMO:{
            COUNTRY:'lb',
            CATEGORIES: categories,
            DEFAULT_LANG: { CODE: "en"  },
            AVAILABLE_LANGUAGES: [
                { CODE: "en" },
                { CODE: "ar" },
                { CODE: "fr" },
            ]
        },
        //asiacell iraq
        ASIACELL_IRAQ:{
            COUNTRY:'iq',
            CATEGORIES: categoriesAsiacell,
            DEFAULT_LANG: { CODE: "ar"  },
            AVAILABLE_LANGUAGES: [
                { CODE: "en" },
                { CODE: "ar" },
            ]
        },
        //ALGERIA
        ALGERIA:{
            COUNTRY:'dz',
            CATEGORIES: categories,
            DEFAULT_LANG: { CODE: "fr"  },
            AVAILABLE_LANGUAGES: [
                { CODE: "fr" }
            ]
        },
        OOREDOO_ALGERIA:{
            COUNTRY:'dz',
            CATEGORIES: categories,
            DEFAULT_LANG: { CODE: "fr"  },
            AVAILABLE_LANGUAGES: [
                { CODE: "fr" },
                { CODE: "en" },
                { CODE: "ar" },
            ]
        },
        //NTH FRANCE
        NTH_FRANCE:{
            COUNTRY:'fr',
            CATEGORIES: categories,
            DEFAULT_LANG: { CODE: "fr"  },
            AVAILABLE_LANGUAGES: [
                { CODE: "fr" }
            ]
        },
        ROMANIA:{
            COUNTRY:'ro',
            CATEGORIES: categories,
            DEFAULT_LANG: { CODE: "ro" },
            AVAILABLE_LANGUAGES: [
                { CODE: "ro" },
            ]
        },
        POLAND:{
            COUNTRY:'pl',
            CATEGORIES: categories,
            DEFAULT_LANG: { CODE: "pl" },
            AVAILABLE_LANGUAGES: [
                { CODE: "pl" },
            ]
        },
        SIRLANKA:{
            COUNTRY:'lk',
            CATEGORIES: categories,
            DEFAULT_LANG: { CODE: "en" },
            AVAILABLE_LANGUAGES: [
                { CODE: "en" },
                { CODE: "fr" },
            ]
        },
        BANGLADESH:{
            COUNTRY:'bd',
            CATEGORIES: categories,
            DEFAULT_LANG: { CODE: "en" },
            AVAILABLE_LANGUAGES: [
                { CODE: "en" },
                { CODE: "fr" },
            ],
            Sub_link:"https://bd.wellbeprime.com"
        },
        


    }

};